import { render, staticRenderFns } from "./CompanyBindCharge.vue?vue&type=template&id=2e2e7603&scoped=true"
import script from "./CompanyBindCharge.vue?vue&type=script&lang=js"
export * from "./CompanyBindCharge.vue?vue&type=script&lang=js"
import style0 from "./CompanyBindCharge.vue?vue&type=style&index=0&id=2e2e7603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e7603",
  null
  
)

export default component.exports